import { useEffect, useState } from 'react';
import Modal from 'react-modal';
import './CommentImages.css';
import useNewReactModal from '../../hooks/useNewReactModal';
import { TrashButton } from '../TrashButton';
import { ConfirmModal } from '../ConfirmModal';
import useComments from '../../hooks/useComments';

interface Image {
  id: number;
  image: string;
  thumb: string;
}
interface Props {
  images: Image[];
  isPanel: boolean;
}

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    maxWidth: '1000px',
    width: '90%',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  overlay: {
    zIndex: 1000,
  },
};
function CommentImages(porps: Props) {
  const [zoomImage, setZoomImage] = useState('');
  const [deleteImageID, setDeleteImageID] = useState<number | null>(null);
  const { openModal, closeModal, modalIsOpen } = useNewReactModal();
  const [listImages, setListImages] = useState<Image[] | never[]>([]);
  const { deleteCommentImage, commentsLoading } = useComments();
  const {
    openModal: openModalConfirm,
    closeModal: closeModalConfirm,
    modalIsOpen: modalIsOpenConfirm,
  } = useNewReactModal();

  const handleZoomImage = (image: string) => {
    setZoomImage(image);
    openModal();
  };

  const handleOpenModalDeleteImage = (id: number) => {
    setDeleteImageID(id);
    openModalConfirm();
  };

  const handleDeleteImage = async () => {
    if (!deleteImageID) {
      return;
    }

    const res = await deleteCommentImage(deleteImageID!);
    if (res.status === 204) {
      setListImages(listImages.filter((image) => image.id !== deleteImageID!));
    }
    closeModalConfirm();
  };

  const { images, isPanel } = porps;

  useEffect(() => {
    setListImages(images);
  }, [images]);

  return (
    <div id="comment-images" data-isPanel={isPanel}>
      <ConfirmModal
        isOpen={modalIsOpenConfirm}
        onRequestClose={closeModalConfirm}
        onConfirm={handleDeleteImage}
        message="Tem certeza que deseja excluir a foto? Após realizar essa ação a foto não será exibida com este comentário."
        title="Excluir foto"
        loading={commentsLoading}
      />
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Example Modal"
        style={customStyles}
        id={
          isPanel === true ? 'modal-comment-image-panel' : 'modal-comment-image'
        }
      >
        {isPanel === true && (
          <div className="modal-header-panel">
            <p className="modal-panel-title">Visualizar foto</p>
          </div>
        )}
        <img src={zoomImage} alt="comment" className="comment-image-zoom" />
        <button className="comment-image-close" onClick={closeModal}>
          <span></span>
        </button>
      </Modal>
      {listImages.map((image) => (
        <div className={isPanel ? 'comment-image-panel' : 'comment-image'}>
          {isPanel ? (
            <TrashButton onClick={() => handleOpenModalDeleteImage(image.id)} />
          ) : null}
          <img
            key={image.id}
            src={image.thumb}
            alt="comment"
            onClick={() => handleZoomImage(image.image)}
          />
        </div>
      ))}
    </div>
  );
}
export default CommentImages;
